import { render } from "./download-zone.vue?vue&type=template&id=295e312a&scoped=true&ts=true"
import script from "./download-zone.vue?vue&type=script&lang=ts"
export * from "./download-zone.vue?vue&type=script&lang=ts"

import "./download-zone.vue?vue&type=style&index=0&id=295e312a&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295e312a"]])

export default __exports__